export default function priceSimplificationUtil(product) {
  const { badges = [] } = product?.product?.pricing;
  const finalPrice = badges.length > 1 ? badges[1].finalPrice : false;
  if (finalPrice) {
    product.product.pricing.price.finalPrice = finalPrice;
  }
  return product;
}
